// extracted by mini-css-extract-plugin
export var container = "index-module--container--2gt_1";
export var successClass = "index-module--successClass--WmvRN";
export var content = "index-module--content--3z1Ul";
export var buttonClass = "index-module--buttonClass--3H1rk";
export var pairClass = "index-module--pairClass--3Sirb";